import { useCallback, useContext } from 'react';

import {
  ErrorFromBack,
  getUniqueBuiltErrorNotifications,
  MessageDescriptorMap,
} from '../../../../helpers/errorsMessage';
import BannersProviderContext from '../BannersProvider.context';
import { NotificationId } from '../BannersProvider.types';

export type UsePushErrorsReturnType = (
  errors: (Error | ErrorFromBack)[],
) => NotificationId[];

interface UsePushErrorsArgs {
  extendedMessages?: MessageDescriptorMap;
}

const usePushErrors = ({
  extendedMessages,
}: UsePushErrorsArgs = {}): UsePushErrorsReturnType => {
  const { pushNotifications } = useContext(BannersProviderContext);

  return useCallback(
    (errors: (Error | ErrorFromBack)[]) => {
      const notifications = getUniqueBuiltErrorNotifications({
        errors,
        extendedMessages,
      });

      return pushNotifications(notifications);
    },
    [extendedMessages, pushNotifications],
  );
};

export default usePushErrors;
